var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"input-group inputs"},[_c('input',{attrs:{"id":_vm.id}}),_c('label',{staticClass:"control-label",attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.title))]),_c('i',{staticClass:"bar"})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }